import { isEmpty } from "lodash-es";

import { PasswordValidity } from "../validators";

/**
 * Validates if the password has an acceptable strength.
 */
export function isPasswordValid(password: string, passwordValidity: PasswordValidity): boolean {
	return (
		!isEmpty(password) &&
		password.length >= passwordValidity.minimumLength &&
		(!passwordValidity.maximumLength || password.length <= passwordValidity.maximumLength) &&
		passwordValidity.weak.test(password)
	);
}
